import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionStorageService } from '../web-storage/session-storage/session-storage.service';

@Injectable()
export class DistrictIdInterceptor implements HttpInterceptor {
  constructor (
    private sessionStorageService: SessionStorageService,
  ) { }

  intercept (request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const districtId = this.getDistrictId();
    // No district in session storage (e.g. a fresh tab before CurrentDistrictGuard runs):
    // send the request without the header — a null header value throws inside HttpHeaders
    request = this.isNonDistrictEndpoint(request.url) || !districtId
      ? request
      : request.clone({
        setHeaders: {
          'nv-district-id': districtId,
        },
      });
    return next.handle(request);
  }

  getDistrictId () {
    return this.sessionStorageService.getItem('currentDistrict');
  }

  isNonDistrictEndpoint (requestUrl: string) {
    const endpoints = ['/v1/status', '/v1/districtUsers'];
    return endpoints.some((endpoint) => requestUrl.includes(endpoint));
  }
}
